const o = "_cover_58ob8_1", e = "_coverImage_58ob8_11", t = "_button_58ob8_20", c = "_container_58ob8_31", n = "_ipNotAllowedCover_58ob8_38", _ = {
  cover: o,
  coverImage: e,
  button: t,
  container: c,
  ipNotAllowedCover: n
};
export {
  _ as s
};
